import { useState, useEffect } from "react";
import { EyeIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { editableData as initialData } from "../../components/AddNotesGradesData";
import StudentGradesTable from "../../components/StudentGradesTable";
import StudentFilters from "../../components/StudentFilters";
import EducatorExportReportsOffcanvas from "../../components/EducatorExportReportsOffcanvas"

const AddNotesGrades = ({ permission }) => {

    const [notesExport, setNotesExport] = useState(false);
    const [data, setData] = useState(initialData);

    // callback to update notes/attachments
    const handleUpdate = (index, newValues) => {
        const updated = [...data];
        updated[index] = { ...updated[index], ...newValues, updatedDate: new Date().toLocaleDateString() };
        setData(updated);
    };
    return (
        <>

            <div className="space-y-6">
                <div className="flex justify-between my-4">
                    <div>
                        <StudentFilters />
                    </div>
                    <div>
                        {/* <button onClick={() => setNotesExport(true)} className="bg-primary-600 px-4 py-3 gap-2  items-center rounded-lg text-white text-sm font-medium hover:bg-primary-200 flex justify-between cursor-not-allowed ">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
                            </svg>
                            Export Reports
                        </button> */}
                        {permission?.export === true &&
                            <button className="bg-primary-600 px-4 py-3 gap-2  items-center rounded-lg text-white text-sm font-medium hover:bg-primary-200 flex justify-between cursor-not-allowed ">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
                                </svg>
                                Export
                            </button>
                        }
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="flex justify-between items-center mb-4">

                            <select
                                className="border rounded-lg px-3 py-2 text-sm text-gray-600 focus:outline-none focus:ring-0"
                            >
                                <option>Last 30 days</option>
                                <option>Last 60 days</option>
                                <option>Last 90 days</option>
                            </select>

                            <div className="flex gap-2">

                                {permission?.draftList === true &&
                                    <button

                                        className="bg-secondary-200 text-secondary-900 text-white px-4 py-2 rounded-lg text-sm hover:bg-secondary-700 flex items-center gap-1 cursor-not-allowed">

                                        Draft
                                    </button>
                                }

                                {permission?.saveAllChanges === true &&
                                    <button

                                        className="bg-primary-500 text-white px-5 py-3 rounded-lg text-sm hover:bg-primary-400"
                                    >
                                        Save All Changes
                                    </button>
                                }
                            </div>

                        </div>



                        {/* Editable Table */}
                        <StudentGradesTable data={data} type="save-only" onUpdate={handleUpdate} permission={permission}/>

                        {/* <StudentGradesTable data={editableData} type="log" /> */}
                    </div>
                </div>



                <div className="card">
                    <div className="card-body">
                        <div className="flex justify-between items-center mb-4">

                            {/* <StudentGradesTable data={editableData} type="editable" /> */}
                            <h4 className="text-[19px]  text-gray-500 mb-4"> <span className="font-bold "> Saved Notes & Grades Log </span>(Recent Entries)</h4>


                            {/* <button className="bg-primary-500 text-white px-5 py-3 rounded-lg text-sm hover:bg-primary-400">
                                Save All Changes
                            </button> */}
                        </div>
                        {/* Logs Table */}
                        <StudentGradesTable data={data} type="edit-save" onUpdate={handleUpdate} permission={permission}/>

                    </div>
                </div>


            </div>
            <EducatorExportReportsOffcanvas
                notesExport={notesExport}
                onClose={() => setNotesExport(false)}
            />

        </>
    );
};

export default AddNotesGrades;
